const config = {
  version: "2.3.6",

  revendas: {
    gateway: {
      cnpj: "00221619000126",
      planos: [
        {
          id: 0,
          titulo: "Gratuito",
          preco_mensal: 0,
          preco_terminal: 20,
          preco_pdv: 50,
        },
        {
          id: 1,
          titulo: "Emissor",
          preco_mensal: 100,
          preco_terminal: 20,
          preco_pdv: 50,
        },
        {
          id: 2,
          titulo: "Gestor",
          preco_mensal: 150,
          preco_terminal: 20,
          preco_pdv: 50,
        },
        {
          id: 3,
          titulo: "Indústria",
          preco_mensal: 200,
          preco_terminal: 20,
          preco_pdv: 50,
        },
      ],
    },

    eedoc: {
      cnpj: "63592762000144",
      wl: "eedoc",
      planos: [
        {
          id: 0,
          titulo: "Gratuito",
          preco_mensal: 0,
          preco_terminal: 20,
          preco_pdv: 50,
        },
        {
          id: 1,
          titulo: "Emissor",
          preco_mensal: 30,
          preco_terminal: 20,
          preco_pdv: 50,
        },
        {
          id: 2,
          titulo: "Gestor",
          preco_mensal: 90,
          preco_terminal: 20,
          preco_pdv: 50,
        },
        {
          id: 3,
          titulo: "Indústria",
          preco_mensal: 200,
          preco_terminal: 20,
          preco_pdv: 50,
        },
      ],
    },

    revenda: {
      planos: [
        {
          id: 0,
          titulo: "Gratuito",
          preco_mensal: 0,
          preco_terminal: 10,
          preco_pdv: 30,
        },
        {
          id: 1,
          titulo: "Emissor",
          preco_mensal: 30,
          preco_terminal: 10,
          preco_pdv: 30,
        },
        {
          id: 2,
          titulo: "Gestor",
          preco_mensal: 60,
          preco_terminal: 10,
          preco_pdv: 30,
        },
        {
          id: 3,
          titulo: "Indústria",
          preco_mensal: 100,
          preco_terminal: 10,
          preco_pdv: 30,
        },
      ],
    },
  },
};

export default config;
